import { Component } from "react";
import { formatDate } from "../../common/services/utilities";
import ThemeableAgGrid from "../../common/components/agGrid/ThemeableAgGrid";
import { withTranslation } from "react-i18next";

class AlbertaEnvironmentalTradesTable extends Component {
  // Define column definitions using the getColumnDefs method
  getColumnDefs() {
    return [
      {
        field: "TransactionId",
        headerName: this.props.t("TransactionId"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "TransactionDate",
        headerName: this.props.t("TransactionDate"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Buyer",
        headerName: this.props.t("Buyer"),
        cellRenderer: (params) => {
          const data = params.data;
          return <span>{data.Buyer ?? <i>[Pending]</i>}</span>;
        },
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Seller",
        headerName: this.props.t("Seller"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Quantity",
        headerName: this.props.t("Quantity"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Registry",
        headerName: this.props.t("Registry"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Vintage",
        headerName: this.props.t("Vintage"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "QuantificationProtocol",
        headerName: this.props.t("QuantificationProtocol"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "SerialStart",
        headerName: this.props.t("SerialStart"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "SerialEnd",
        headerName: this.props.t("SerialEnd"),
        filter: false,
        floatingFilter: false,
      },
    ];
  }

  mapToViewModel(trades) {
    return trades.map((trade, index) => ({
      index: index,
      Id: trade.Id,
      TransactionId: trade.TransactionId,
      TransactionDate: formatDate(trade.TransactionDate),
      Buyer: trade.Buyer,
      Seller: trade.Seller,
      Quantity: trade.Quantity,
      Registry: trade.Registry,
      Vintage: trade.Vintage,
      QuantificationProtocol: trade.QuantificationProtocol,
      SerialStart: trade.SerialStart,
      SerialEnd: trade.SerialEnd,
    }));
  }

  render() {
    const { trades, onRowClick } = this.props;

    const mappedTrades = this.mapToViewModel(trades);
    const columnDefs = this.getColumnDefs();

    // Pagination configuration
    const paginationConfig = {
      // Enable pagination for all tables regardless of size
      enabled: true,
      // Default page size
      pageSize: 20,
      // Available page size options for user to choose
      pageSizeOptions: [5, 10, 20, 50, 100],
    };

    return (
      <div style={{ position: "relative" }}>
        <ThemeableAgGrid
          className="table-extra-small"
          columnDefs={columnDefs}
          rowData={mappedTrades}
          onRowClicked={(params) => onRowClick && onRowClick(params.data)}
          getRowId={(params) => String(params.data.index)}
          pagination={true}
          paginationPageSize={paginationConfig.pageSize}
          paginationPageSizeSelector={paginationConfig.pageSizeOptions}
          suppressPaginationPanel={false}
          allowHorizontalScroll={false}
        />

        {/* These overlays will cover up pagination and filters when enabled to replace the custom ones)
            Still some investigation to do to determine what kind of filter restricitons (i.e. date range limitations,
            or maybe this is better handled by only retreiving a limited range for unpriveleged users)

            Filter's in the community version also aren't as robust so may need to wait for enterprise version to use
            things like multi select filter etc. */}
        {/* {true && (
          <div
            style={{
              position: "absolute",
              top: "40px", // typically below header row
              left: 0,
              right: 0,
              height: "40px", // adjust if your filters row is taller
              zIndex: 10,
              //backgroundColor: "rgba(255, 255, 255, 0.5)",
              pointerEvents: "auto",
              cursor: "not-allowed",
            }}
          />
        )}
        {true && (
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              height: "40px", // Approximate height of the pagination controls
              width: "100%",
              backgroundColor: "rgba(255, 255, 255, 0.0)", // semi-transparent white
              zIndex: 10,
              cursor: "not-allowed",
            }}
          />
        )} */}
      </div>
    );
  }
}

export default withTranslation(["marketdata"])(AlbertaEnvironmentalTradesTable);
